<template>
  <div class="notification">
    <transition-group name="list" tag="div">
      <div
        v-for="notification in notifications"
        :key="notification.id"
        class=""
      >
        <v-alert :type="notification.type">
          {{ notification.lang ? $t(notification.lang) : notification.text }}
        </v-alert>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CAlert',
  computed: {
    ...mapGetters('alert', ['notifications']),
  },
};
</script>

<style scoped lang="scss">
.notification {
  position: fixed;
  z-index: 235;
  bottom: 10px;
  right: 10px;
}
.list-enter-active {
  animation: slideInRight;
  animation-duration: 0.3s;
}
.list-leave-active {
  animation: slideOutRight;
  animation-duration: 0.3s;
}
</style>
